import CLogo1 from '../../assets/img/client-50/client-logo1.png';
import CLogo2 from '../../assets/img/client-50/client-logo2.png';
import CLogo3 from '../../assets/img/client-50/client-logo3.png';
import CLogo4 from '../../assets/img/client-50/client-logo4-1.png';
import CLogo6 from '../../assets/img/client-50/client-logo6-1.png';
import CLogo7 from '../../assets/img/client-50/client-logo7.png';
import CLogo15 from '../../assets/img/client-50/client-logo15.png';
import CLogo72 from '../../assets/img/client-50/client-logo72.png';
import CLogo58 from '../../assets/img/client-50/client-logo58.png';
import testiSmallImg1 from '../../assets/img/testiSmallImg1.png';
import testiSmallImg2 from '../../assets/img/testiSmallImg2.png';
import testiImg4 from '../../assets/img/testiImg4.png';
import testiImg5 from '../../assets/img/testiImg5-crop.png';
import testiImg6 from '../../assets/img/testiImg6.png';
import testiImg7 from '../../assets/img/testiImg7.png';
import testiImg8 from '../../assets/img/testiImg8.png';
import testiImg9 from '../../assets/img/testiImg9.png';
import { Carousel } from 'react-bootstrap';
import { useState } from 'react';

const testimonials = [
    {
        imgSrc: testiSmallImg1,
        content:
            'We have seen an 80% reduction in the candidate ghosting rate after introducing OfferX to our hiring process.',
        author: 'Abilash Perumandla',
        position: 'Head of Human Resources, Wallero',
    },
    {
        imgSrc: testiSmallImg2,
        content:
            'OfferX has been a game-changer for us, simplifying our candidate onboarding process and eliminating recruitment ghosting issues.',
        author: 'Anne Priya',
        position: 'HR Manager, Implantaire Technologies (I) Pvt. Ltd.',
    },
    {
        imgSrc: testiImg4,
        content:
            "It is a great initiative that holds immense potential for revolutionizing the recruitment process. It's a game changer, especially for HR professionals like us, providing valuable insights into our prospective candidates!",
        author: 'Sandhya Baskaran',
        position: 'HR Generalist, Acviss Technologies',
    },
    {
        imgSrc: testiImg5,
        content: `Navigating the challenges inherent in our organizational processes has
            been a formidable task, particularly with regard to the issue of
            candidates verbally accepting job offers but subsequently failing to
            adhere to work agreements. This scenario has resulted in instances where
            offer letters are dispatched, yet individuals fail to materialize on the
            stipulated joining date. Furthermore, even after joining, some
            individuals exhibit disinterest in their designated roles and
            responsibilities, ultimately renouncing the offered position.`,
        content2: `This recurrent phenomenon not only consumes significant time and
        resources in the hiring process but also has a detrimental impact on our
        organization. Since the integration of the OfferX platform into our
        operations, however, we have experienced a notable transformation in our
        ability to manage these issues. The platform facilitates streamlined
        tracking of employees, encompassing personal information, offer letter
        dissemination, and acceptance status. Consequently, the rate of
        candidate ghosting has significantly diminished.`,
        content3: `In my professional view, OfferX has proven to be an invaluable tool in
        enhancing our recruitment and onboarding processes, contributing to a
        more efficient and effective organizational workflow.`,
        author: 'Nallagatla Vijaya Ram Gopal',
        position: 'HR Head, ULearn',
    },
    {
        imgSrc: testiImg6,
        content: `OfferX has truly revolutionized our operations, streamlining our candidate onboarding process and eliminating recruitment ghosting issues like never before. Its comprehensive solution allows us to swiftly assess candidate responses and access their complete history.`,
        content2: `We eagerly anticipate future updates that will further enhance this platform. The help center has been an invaluable resource for us, always providing immediate assistance whenever we encounter challenges.`,
        content3: `We are committed to leveraging this platform extensively in the future. I wholeheartedly recommend that all companies explore the benefits of registering on the OfferX platform to simplify and optimize their onboarding processes.`,
        author: 'Nagendra Shivarajegowda',
        position: 'HR Manager, Inspiring Touch',
    },
    {
        imgSrc: testiImg7,
        content: `OfferX has truly revolutionized our operations, streamlining our candidate onboarding process and eliminating recruitment ghosting issues like never before. Its comprehensive solution allows us to swiftly assess candidate responses and access their complete history.`,
        author: 'Sarath Patro',
        position: 'CEO, Revsoc Digital Marketing Agency',
    },
    {
        imgSrc: testiImg8,
        content: `In our experience, last-minute candidate offer ghosting and early-stage attrition are key challenges. After reviewing OfferX's interface, it effectively addresses these issues by ensuring candidates maintain accountability and communicate properly when declining offers, while also tackling absconding due to infant attrition. I wish the OfferX team continued success in their efforts to bridge the gap in managing offer ghosting.`,
        author: 'Rajiv Tiwari',
        position: 'Director Talent Acquisition, Virtusa',
    },
    {
        imgSrc: testiImg9,
        content: `We used the OfferX tool, and it has been performing exceptionally well. The platform is user-friendly and highly presentable, with its approach receiving significant appreciation. OfferX effectively addresses a critical issue for recruiters: employee ghosting. It allows us to send offers to potential employees and efficiently record their details. The platform’s comprehensive statistics feature enables us to track how many offers were sent, who accepted or declined, and the reasons behind their decisions. This helps us build a robust database for future hiring. Additionally, the tool includes a two-way review system for both applicants and employers, specifically addressing cases of ghosting. I believe this platform has the potential to become a game-changer in the industry.`,
        author: 'Vinod Kumar',
        position: 'HR Manager, ComTec IT Services India P Ltd.',
    },
];

const RegistrationTestimonials = () => {
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const handleCarouselSelect = (selectedIndex: number | null) => {
        setExpandedIndex(null);
    };
    return (
        <>
            <div className="reg-testimonials">
                <Carousel onSelect={handleCarouselSelect}>
                    {testimonials.map((testimonial, index) => (
                        <Carousel.Item key={index}>
                            <div className="d-flex">
                                <div className="profile-pic reg-profile-pic w-auto h-auto">
                                    <img
                                        src={testimonial.imgSrc}
                                        className="avatar avatar--sm"
                                        style={{ objectPosition: 'top' }}
                                        alt=""
                                    />
                                </div>
                                <div className="ms-3">
                                    <div>
                                        {testimonial.content.length > 250 ? (
                                            <>
                                                <div className="scroll-crop">
                                                    {expandedIndex === index ? (
                                                        <span>
                                                            <p className="fs-14 lt-text-secondary mb-3 w-75">
                                                                {testimonial.content}
                                                            </p>
                                                            {testimonial.content2 && (
                                                                <p className="fs-14 lt-text-secondary mb-3 w-75">
                                                                    {testimonial.content2}
                                                                </p>
                                                            )}
                                                            {testimonial.content3 && (
                                                                <p className="fs-14 lt-text-secondary mb-0 w-75">
                                                                    {testimonial.content3}
                                                                </p>
                                                            )}
                                                        </span>
                                                    ) : (
                                                        <span className="fs-14 lt-text-secondary mb-3 w-75">
                                                            {testimonial.content.slice(0, 250)}...
                                                        </span>
                                                    )}
                                                    <span>
                                                        <button
                                                            className="btn btn-link p-0 lt-text-primary-alt"
                                                            onClick={() =>
                                                                setExpandedIndex(expandedIndex === index ? null : index)
                                                            }
                                                        >
                                                            {expandedIndex === index ? 'Read less' : 'Read more'}
                                                        </button>
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <p className="fs-14 lt-text-secondary mb-3 w-75">{testimonial.content}</p>
                                        )}
                                    </div>
                                    <p className="fs-14 fw-600 lt-text-primary mt-3">{testimonial.author}</p>
                                    <p className="fs-14 lt-text-secondary">{testimonial.position}</p>
                                </div>
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
            <div className="mt-7">
                <div className="fs-16 fw-600 mb-3">Over 2500+ Companies Trust OfferX</div>
                <div className="mx-auto d-block">
                    <div className="row">
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo1} alt="CIEL HR" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo2} alt="Sun Technologies" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo3} alt="BDS Services" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo4} alt="Delaplex" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo58} alt="Wallero Technologies" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo6} alt="Palni" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo7} alt="Quarks" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo72} alt="Cosette Network" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                        <div className="col-md-3 logos-border d-flex align-items-center justify-content-center">
                            <div className="p-3">
                                <img loading='lazy'src={CLogo15} alt="Inventum" className="img-fluid mx-auto d-block" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegistrationTestimonials;
